/* global document */
import * as R from 'ramda';

export default function SettingsDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  bcpDataService,
) {
  const vm = this;

  vm.customerTeamCurrentTeamTypeId = '1';

  vm.mediaUsers = [];
  vm.mediaOptions = [];

  vm.mediaPrimaryOptions = [];
  vm.mediaSecondaryOptions = [];
  vm.mediaTertiaryOptions = [];

  vm.handleExpandSettingsSection = _handleExpandSettingsSection;
  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSaveSettings = _handleSaveSettings;

  vm.customerTeamsFilterd = _customerTeamsFilterd;
  vm.handleTeamDisplayDrop = _handleTeamDisplayDrop;
  vm.handleMoveTeamDisplayDrop = _handleMoveTeamDisplayDrop;
  vm.handleDisableTeamDisplay = _handleDisableTeamDisplay;
  vm.riskWeightValidator = _riskWeightValidator;
  vm.riskWeightValidationMessage = _riskWeightValidationMessage;
  vm.IsValidControl = _IsValidControl;
  vm.isTeamDisplayColumnConfigurationValid = _isTeamDisplayColumnConfigurationValid;
  vm.handleMediaContactChange = _handleMediaContactChange;
  vm.getAutocompleteItemClass = _getAutocompleteItemClass;

  _activate();

  // //////// METHODS //////////


  function _activate() {

    // Users
    R.forEach((user) => {
      const mediaOption = {
        isVendor: false,
        name: user.fullName,
        planPriority: null,
        userId: user.userId,
        vendorId: null,
      };
      if (mediaOption.name === null) {
        mediaOption.name = '<Unknown>';
      }
      vm.mediaUsers.push(mediaOption);
      vm.mediaOptions.push(mediaOption);
    }, vm.users);

    // Vendors
    R.forEach((vendor) => {
      const mediaOption = {
        isVendor: true,
        name: vendor.name,
        planPriority: null,
        userId: null,
        vendorId: vendor.vendorId,
      };
      if (mediaOption.name === null) {
        mediaOption.name = '<Unknown>';
      }
      vm.mediaOptions.push(mediaOption);
    }, vm.vendors);

    vm.mediaUsers = _sort(vm.mediaUsers, 'name');
    vm.mediaOptions = _sort(vm.mediaOptions, 'name');

    vm.mediaPrimaryOptions = vm.mediaUsers;
    vm.mediaSecondaryOptions = vm.mediaOptions;
    vm.mediaTertiaryOptions = vm.mediaOptions;

    _extractMediaContacts();

    if (!vm.settings.customerConfiguration.disasterDeclarationText) {
      vm.settings.customerConfiguration.disasterDeclarationText = '';
    }
    if (!vm.settings.customerConfiguration.regulatorNotificationText) {
      vm.settings.customerConfiguration.regulatorNotificationText = '';
    }
    if (!vm.settings.customerConfiguration.mediaResponseText) {
      vm.settings.customerConfiguration.mediaResponseText = '';
    }
    if (!vm.settings.customerConfiguration.planDistributionText) {
      vm.settings.customerConfiguration.planDistributionText = '';
    }
    
    _mergeThreatTypesWithThreatCategories();

    loaderService.showViewLoader = false;
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.settingsDialog);
  }

  function _handleSaveSettings() {
    if ($scope.editBCPSettingsForm.$invalid || !_isTeamDisplayColumnConfigurationValid($scope.editBCPSettingsForm)) {
      return false;
    }
    loaderService.showViewLoader = true;
    _transformContactsToSave();
    return bcpDataService.saveSettings(vm.settings).then((response) => {
      loaderService.showViewLoader = false;
      if (!response.data) {
        alerts.error('Error occurred while saving the BCP Blueprint Settings.');
      } else {
        alerts.success('The BCP BCP Blueprint Settings have been saved successfully.');
        $rootScope.$broadcast('refreshBCPTeamAndContactSettings');
        ssDialogService.hide(ssDialogService.dialogs.bcp.settingsDialog);
      }
    });
  }  

  function _transformContactsToSave() {
    if (vm.primaryMediaContact) {
      vm.settings.customerConfiguration.primaryMediaContactName = vm.primaryMediaContact.name;
      vm.settings.customerConfiguration.primaryMediaContactUserId = vm.primaryMediaContact.userId;
      vm.settings.customerConfiguration.primaryMediaContactVendorId = vm.primaryMediaContact.vendorId;
    } else {
      vm.settings.customerConfiguration.primaryMediaContactName = null;
      vm.settings.customerConfiguration.primaryMediaContactUserId = null;
      vm.settings.customerConfiguration.primaryMediaContactVendorId = null;
    }

    if (vm.secondaryMediaContact) {
      vm.settings.customerConfiguration.secondaryMediaContactName = vm.secondaryMediaContact.name;
      vm.settings.customerConfiguration.secondaryMediaContactUserId = vm.secondaryMediaContact.userId;
      vm.settings.customerConfiguration.secondaryMediaContactVendorId = vm.secondaryMediaContact.vendorId;
    } else {
      vm.settings.customerConfiguration.secondaryMediaContactName = null;
      vm.settings.customerConfiguration.secondaryMediaContactUserId = null;
      vm.settings.customerConfiguration.secondaryMediaContactVendorId = null;
    }

    if (vm.tertiaryMediaContact) {
      vm.settings.customerConfiguration.tertiaryMediaContactName = vm.tertiaryMediaContact.name;
      vm.settings.customerConfiguration.tertiaryMediaContactUserId = vm.tertiaryMediaContact.userId;
      vm.settings.customerConfiguration.tertiaryMediaContactVendorId = vm.tertiaryMediaContact.vendorId;
    } else {
      vm.settings.customerConfiguration.tertiaryMediaContactName = null;
      vm.settings.customerConfiguration.tertiaryMediaContactUserId = null;
      vm.settings.customerConfiguration.tertiaryMediaContactVendorId = null;
    }
  }

  // Expand/Collapse
  function _handleExpandSettingsSection($event, section) {
    vm[`${section}IsExpanded`] = !vm[`${section}IsExpanded`];
  }

  function _riskWeightValidator(form, fld, attr) {
    if (form && form.$submitted) {
      const id = fld + attr;
      return form[id].$invalid;
    }
    return false;
  }

  function _riskWeightValidationMessage(form, fld, attr) { // eslint-disable-line consistent-return
    if (form && form.$submitted) {
      const id = fld + attr;
      return form[id].$error;
    }
  }

  function _IsValidControl(control) {
    return ($scope.editBCPSettingsForm)
      && (($scope.editBCPSettingsForm.$submitted && control.$invalid) || (control.$dirty && control.$invalid));
  }

  function _customerTeamsFilterd() {
    return R.reject(
      R.anyPass([
        R.propEq('customerTeamId', 9),
        R.propEq('customerTeamId', 10)
      ])
    )(vm.settings.customerTeams);
  }

  function _handleDisableTeamDisplay(teamTypeId, listType) {
    let result = false;
    const teamConfigs = R.filter(
      R.allPass([
        R.propEq('teamTypeId', teamTypeId),
        R.propEq('selected', true),
      ]),
      vm.settings.customerTeamDisplayConfigurations
    );

    if (teamConfigs) {
      if (listType === 'unsorted') {
        result = teamConfigs.length > 3;
      } else if (listType === 'sorted') {
        result = teamConfigs.length < 2;
      }
    }

    return result;
  }

  function _handleMoveTeamDisplayDrop(item, index, external, type, event) { // eslint-disable-line no-unused-vars
    const teamconfig = R.find(c => c.customerTeamDisplayConfigurationId === item.customerTeamDisplayConfigurationId,
      vm.settings.customerTeamDisplayConfigurations);

    if (teamconfig) {
      if (type.indexOf('teamSrcConfig') > -1 && teamconfig.selected === false) {
        teamconfig.selected = true;
      }

      teamconfig.sortOrder = index;
      _updateTeamDisplaySort(teamconfig, index);
    }
    return item;
  }

  function _handleTeamDisplayDrop(item, index, external, type, event) { // eslint-disable-line no-unused-vars
    if (type.indexOf('teamConfig') > -1) {
      const teamConfig = R.find(
        R.allPass([
          R.propEq('customerTeamDisplayConfigurationId', item.customerTeamDisplayConfigurationId),
          R.propEq('teamTypeDisplayOptionId', item.teamTypeDisplayOptionId),
          R.propEq('teamTypeId', item.teamTypeId)
        ]),
        vm.settings.customerTeamDisplayConfigurations
      );

      if (teamConfig) {
        teamConfig.selected = false;
        teamConfig.sortOrder = 99;

        // _updateTeamDisplaySort(teamConfig, index);
      }
    }

    return item;
  }

  function _updateTeamDisplaySort(teamConfig, index) {
    const elem = R.sortBy(
      R.prop('sortOrder'),
      R.filter(
        n => (
          n.teamTypeId === teamConfig.teamTypeId
          && n.selected
          && n.customerTeamDisplayConfigurationId !== teamConfig.customerTeamDisplayConfigurationId
        ),
        vm.settings.customerTeamDisplayConfigurations
      )
    );

    angular.forEach(elem, (c, idx) => {
      if (c) {
        c.sortOrder = (idx + (idx < index - 1 ? 1 : 2));
      }
    });
  }

  function _isTeamDisplayColumnConfigurationValid(form) {
    let flag = true;
    const controls = document.querySelectorAll('.bcp-settings--section-teamdisplay-ol input:first-child');

    if (controls) {
      angular.forEach(controls, (c) => {
        const control = form[c.id];
        if (control && control.$invalid) {
          flag = false;
        }
      });
    }
    return flag;
  }

  function _mergeThreatTypesWithThreatCategories() {
    angular.forEach(vm.settings.threatCategories, (threatCategory) => {
      const threatTypes = R.filter(item => (item.threatCategoryId === threatCategory.threatCategoryId), vm.settings.customerThreatTypes);

      if ((threatTypes !== undefined) && (threatTypes.length > 0))
      {
        threatCategory.threatTypes = R.sortBy(R.prop('sortOrder'), threatTypes);
      }
    });
  }
  
  function _extractMediaContacts() {
    if (vm.mediaOptions && vm.mediaOptions.length > 0) {
      if (vm.settings.customerConfiguration.primaryMediaContactName !== null) {
        const primaryMediaContactName = vm.settings.customerConfiguration.primaryMediaContactName;
        const findPrimary = R.filter(R.propEq('name', primaryMediaContactName), vm.mediaOptions);
        if (findPrimary) {
          vm.primaryMediaContact = findPrimary[0];
        }
      }
      if (vm.settings.customerConfiguration.secondaryMediaContactName !== null) {
        const secondaryMediaContactName = vm.settings.customerConfiguration.secondaryMediaContactName;
        const findSecondary = R.filter(R.propEq('name', secondaryMediaContactName), vm.mediaOptions);
        if (findSecondary) {
          vm.secondaryMediaContact = findSecondary[0];
        }
      }
      if (vm.settings.customerConfiguration.tertiaryMediaContactName !== null) {
        const tertiaryMediaContactName = vm.settings.customerConfiguration.tertiaryMediaContactName;
        const findTertiary = R.filter(R.propEq('name', tertiaryMediaContactName), vm.mediaOptions);
        if (findTertiary) {
          vm.tertiaryMediaContact = findTertiary[0];
        }
      }
    }
  }

  function _handleMediaContactChange(acvm) {
    const item = acvm.selectedItem;
    const position = acvm.position;

    const isPrimaryContact = (vm.primaryMediaContact !== undefined) && (vm.primaryMediaContact !== null) && (item !== null)
      && (((vm.primaryMediaContact.isVendor === true) && (vm.primaryMediaContact.vendorId === item.vendorId))
        || ((vm.primaryMediaContact.isVendor === false) && (vm.primaryMediaContact.userId === item.userId)));

    const isSecondaryContact = (vm.secondaryMediaContact !== undefined) && (vm.secondaryMediaContact !== null) && (item !== null)
      && (((vm.secondaryMediaContact.isVendor === true) && (vm.secondaryMediaContact.vendorId === item.vendorId))
        || ((vm.secondaryMediaContact.isVendor === false) && (vm.secondaryMediaContact.userId === item.userId)));

    const isTertiaryContact = (vm.tertiaryMediaContact !== undefined) && (vm.tertiaryMediaContact !== null) && (item !== null)
      && (((vm.tertiaryMediaContact.isVendor === true) && (vm.tertiaryMediaContact.vendorId === item.vendorId))
        || ((vm.tertiaryMediaContact.isVendor === false) && (vm.tertiaryMediaContact.userId === item.userId)));

    if (position === 'primary') {
      if (isSecondaryContact) {
        alerts.error('The Primary Media Contact cannot be the same as the Secondary Media Contact. Please choose a different option.');
        acvm.selectedItem = null;
      } else if (isTertiaryContact) {
        alerts.error('The Primary Media Contact cannot be the same as the Tertiary Media Contact. Please choose a different option.');
        acvm.selectedItem = null;
      }
    } else if (position === 'secondary') {
      if (isPrimaryContact) {
        alerts.error('The Secondary Media Contact cannot be the same as the Primary Media Contact. Please choose a different option.');
        acvm.selectedItem = null;
      } else if (isTertiaryContact) {
        alerts.error('The Secondary Media Contact cannot be the same as the Tertiary Media Contact. Please choose a different option.');
        acvm.selectedItem = null;
      }
    } else if (position === 'tertiary') {
      if (isPrimaryContact) {
        alerts.error('The Tertiary Media Contact cannot be the same as the Primary Media Contact. Please choose a different option.');
        acvm.selectedItem = null;
      } else if (isSecondaryContact) {
        alerts.error('The Tertiary Media Contact cannot be the same as the Secondary Media Contact. Please choose a different option.');
        acvm.selectedItem = null;
      }
    }
  }

  function _getAutocompleteItemClass(item) {
    if (!item) {
      return '';
    }
    return item.isVendor ? 'vendor' : 'person';
  }

  function _sort(collection, key) {
    return collection.sort((a, b) => {
      const aValue = _getSortableValue(a, key);
      const bValue = _getSortableValue(b, key);
      if (aValue < bValue) return -1;
      if (aValue > bValue) return 1;
      return 0;
    });
  }

  function _getSortableValue(obj, key) {
    return typeof obj[key] === 'string' ? obj[key].toLowerCase() : obj[key];
  }
}

SettingsDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'bcpDataService',
];
